import { z } from 'zod';

export const templateSchema = z.object({
  id: z.number().int().positive(),
  formatId: z.number().int().positive(),
  code: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  previewVideoUrl: z.string().nullable(),
  questions: z.array(z.string()),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
});

export type Template = z.infer<typeof templateSchema>;

/** Для списков в TMA: без system_prompt, чтобы не утекало на клиент. */
export const templatePublicSchema = templateSchema.pick({
  id: true,
  formatId: true,
  code: true,
  title: true,
  description: true,
  previewVideoUrl: true,
  questions: true,
  sortOrder: true,
});

export type TemplatePublic = z.infer<typeof templatePublicSchema>;
